import { Skeleton } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";

import api from "../../../BrandOnBoarding/api";
import { getBrandDescriptionPrompt } from "../../../utils/prompt";
import { DiscoveryContext } from "../discovery-context";
import ErrorMessage from "./../../../Component/ErrorMessage/ErrorMessage";
import classes from "./Description.module.css";

export default function Description({ entity, category }) {
  const abortControllerRef = useRef(null);
  const [error, setError] = useState();

  const discoveryCtx = useContext(DiscoveryContext);

  async function getBrandDescription() {
    setError(null);

    abortControllerRef.current = new AbortController();
    let language = discoveryCtx.language;
    let prompt = getBrandDescriptionPrompt(entity, category, language);
    const payload = {
      llm: discoveryCtx.llm,
      prompt: prompt,
    };

    try {
      let response = await api.post(`/llm-execute`, payload, {
        signal: abortControllerRef.current.signal,
      });
      discoveryCtx.updateBrandDescription(response.data.data);
    } catch (error) {
      console.log("Something went wrong", error);
      setError(error.message);
    }
  }

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  useEffect(() => {
    if (discoveryCtx?.brand_description.length > 0) return;
    getBrandDescription(entity);

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [entity, discoveryCtx?.brand_description.length]);

  let brandDescription = null;
  let loading = true;
  if (discoveryCtx?.brand_description.length > 0) {
    brandDescription = discoveryCtx.brand_description;
    loading = false;
  }

  return (
    <div className={classes.text}>
      {loading && !error && (
        <>
          <Skeleton />
          <Skeleton style={{ width: "50%" }} />
        </>
      )}
      {!error && !loading && brandDescription}
      {error && (
        <ErrorMessage
          message={error}
          retry
          align="left"
          onRetry={() => getBrandDescription()}
        />
      )}
    </div>
  );
}
